export default __webpack_public_path__ + "static/media/location-3.c4123bba.png";